import { localStorage } from "./localStorage";

export const RELOAD_KEY = 'elsaErrorChunk';

const originalLoad = __webpack_chunk_load__;
__webpack_chunk_load__ = (id: number) => {
  return originalLoad(id).then(
    (chunk) => {
      const errorChunkId = localStorage.get(RELOAD_KEY);
      if (+errorChunkId === id) localStorage.remove(RELOAD_KEY);
      return chunk;
    },
    (error) => {
      if (error instanceof Error && error.name === 'ChunkLoadError') {
        const errorChunkId = localStorage.get(RELOAD_KEY);
        if (!errorChunkId && +errorChunkId !== id) {
          localStorage.set(RELOAD_KEY, id + '');
          setTimeout(() => window.location.reload(), 100);
        } else {
          throw error;
        }
      } else {
        throw error;
      }
    }
  );
};

setTimeout(() => {
  localStorage.remove(RELOAD_KEY);
}, 60000);